import { render, staticRenderFns } from "./NumberMatcher.vue?vue&type=template&id=380369d1&scoped=true&"
import script from "./NumberMatcher.vue?vue&type=script&lang=js&"
export * from "./NumberMatcher.vue?vue&type=script&lang=js&"
import style0 from "./NumberMatcher.vue?vue&type=style&index=0&id=380369d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380369d1",
  null
  
)

export default component.exports